import type { MetadataFieldType } from '@iconik-io/iconik-api/src/types/metadata_field_type';

import type { IconType } from '../icons/constants';
import { ICONS } from '../icons/icon';
import type { SelectOption } from '../ui/select_field/types';

export const SEGMENT_TAGS_VIEW_NAME = 'Segment Tags';

export const FIELDS = {
  TEXT: 'text',
  DATE: 'date',
  DATETIME: 'datetime',
  DROPDOWN: 'drop_down',
  EMAIL: 'email',
  FLOAT: 'float',
  INTEGER: 'integer',
  STRINGEXACT: 'string_exact',
  STRING: 'string',
  TAGCLOUD: 'tag_cloud',
  BOOLEAN: 'boolean',
  SEPARATOR: '__separator__',
  URL: 'url',
} as const;

export const FIELDS_METADATA_MAPPING: MetadataFieldType[] = [
  FIELDS.INTEGER,
  FIELDS.FLOAT,
  FIELDS.BOOLEAN,
  FIELDS.STRING,
  FIELDS.STRINGEXACT,
  FIELDS.TEXT,
  FIELDS.TAGCLOUD,
  FIELDS.URL,
  FIELDS.DATE,
  FIELDS.DATETIME,
  FIELDS.DROPDOWN,
];

export const FIELD_ICONS: { [key in MetadataFieldType]?: IconType } = {
  [FIELDS.TEXT]: ICONS.Text,
  [FIELDS.DATE]: ICONS.Calendar,
  [FIELDS.DATETIME]: ICONS.Datetime,
  [FIELDS.DROPDOWN]: ICONS.Dropdown,
  [FIELDS.EMAIL]: ICONS.Mail,
  [FIELDS.FLOAT]: ICONS.Float,
  [FIELDS.INTEGER]: ICONS.Integer,
  [FIELDS.STRING]: ICONS.String,
  [FIELDS.STRINGEXACT]: ICONS.String,
  [FIELDS.TAGCLOUD]: ICONS.Tag,
  [FIELDS.URL]: ICONS.Link,
  [FIELDS.BOOLEAN]: ICONS.Switch,
  [FIELDS.SEPARATOR]: ICONS.Divide,
};

export const FIELD_LABELS = {
  [FIELDS.TEXT]: 'Text Area',
  [FIELDS.DATE]: 'Date',
  [FIELDS.DATETIME]: 'Datetime',
  [FIELDS.DROPDOWN]: 'Dropdown',
  [FIELDS.EMAIL]: 'E-mail',
  [FIELDS.FLOAT]: 'Float',
  [FIELDS.INTEGER]: 'Integer',
  [FIELDS.STRING]: 'Text',
  [FIELDS.STRINGEXACT]: 'Tag cloud',
  [FIELDS.TAGCLOUD]: 'Tag cloud',
  [FIELDS.URL]: 'Url',
  [FIELDS.BOOLEAN]: 'Yes/No',
  [FIELDS.SEPARATOR]: 'Divider',
};

export type MetadataTypeSelectOption = SelectOption & {
  icon?: IconType;
};

export const metadataTypes: MetadataTypeSelectOption[] = [
  {
    label: FIELD_LABELS[FIELDS.DATE],
    value: FIELDS.DATE,
    icon: FIELD_ICONS[FIELDS.DATE],
  },
  {
    label: FIELD_LABELS[FIELDS.DATETIME],
    value: FIELDS.DATETIME,
    icon: FIELD_ICONS[FIELDS.DATETIME],
  },
  {
    label: FIELD_LABELS[FIELDS.DROPDOWN],
    value: FIELDS.DROPDOWN,
    icon: FIELD_ICONS[FIELDS.DROPDOWN],
  },
  {
    label: FIELD_LABELS[FIELDS.EMAIL],
    value: FIELDS.EMAIL,
    icon: FIELD_ICONS[FIELDS.EMAIL],
  },
  {
    label: FIELD_LABELS[FIELDS.FLOAT],
    value: FIELDS.FLOAT,
    icon: FIELD_ICONS[FIELDS.FLOAT],
  },
  {
    label: FIELD_LABELS[FIELDS.INTEGER],
    value: FIELDS.INTEGER,
    icon: FIELD_ICONS[FIELDS.INTEGER],
  },
  {
    label: FIELD_LABELS[FIELDS.TAGCLOUD],
    value: FIELDS.TAGCLOUD,
    icon: FIELD_ICONS[FIELDS.TAGCLOUD],
  },
  {
    label: FIELD_LABELS[FIELDS.TEXT],
    value: FIELDS.TEXT,
    icon: FIELD_ICONS[FIELDS.TEXT],
  },
  {
    label: FIELD_LABELS[FIELDS.STRING],
    value: FIELDS.STRING,
    icon: FIELD_ICONS[FIELDS.STRING],
  },
  {
    label: FIELD_LABELS[FIELDS.URL],
    value: FIELDS.URL,
    icon: FIELD_ICONS[FIELDS.URL],
  },
  {
    label: FIELD_LABELS[FIELDS.BOOLEAN],
    value: FIELDS.BOOLEAN,
    icon: FIELD_ICONS[FIELDS.BOOLEAN],
  },
];

export const DEFAULT_CATEGORY_NAME = 'default';
